import _assign from 'lodash/assign';
import _get from 'lodash/get';
import ActionTypes from '../constants/ActionTypes';
import initialState from '../store/initialState';

export default (state = initialState.solutions, action) => {
  switch (action.type) {
    case `${ActionTypes.GET_PROBLEM_SOLUTION}_SUCCESS`: {
      const solution = action.payload;
      const problemSlug = _get(solution, 'problem.slug');
      return _assign({}, state, { [problemSlug]: solution });
    }
    // Todo: Rename this ACTION
    case `${ActionTypes.SAVE_SOLUTION}_SUCCESS`: {
      const solution = action.payload;
      const problemSlug = _get(solution, 'problem.slug');
      return _assign({}, state, { [problemSlug]: solution });
    }
    case `${ActionTypes.SAVE_CLUSTER_SOLUTION}_SUCCESS`: {
      const solution = action.payload;
      const { clusterSlug } = solution || {};
      const problemSlug = solution.problem.slug;
      const newState = { ...state };
      const newClusterState = {
        ...(newState[clusterSlug] || {}),
        ...(problemSlug ? { [problemSlug]: solution } : {}),
      };
      return {
        ...state,
        ...(clusterSlug ? { [clusterSlug]: newClusterState } : {}),
      };
    }
    case `${ActionTypes.SAVE_SOLUTION}_LIST_SUCCESS`: {
      return { ...state, ...action.payload };
    }
    case `${ActionTypes.CLEAR_SOLUTION}_SUCCESS`: {
      const newSolutionsState = { ...state };
      const { clusterSlug, problemSlug } = action;
      if (clusterSlug) {
        delete newSolutionsState[clusterSlug][problemSlug];
        if (Object.keys(newSolutionsState[clusterSlug]).length === 0)
          delete newSolutionsState[clusterSlug];
      }
      if (problemSlug) delete newSolutionsState[problemSlug];
      return newSolutionsState;
    }
    case `${ActionTypes.AUDIO_UPLOAD}_STATUS`:
    case `${ActionTypes.VIDEO_UPLOAD}_STATUS`: {
      const newState = { ...state };
      if (newState[action.problemSlug]) {
        newState[action.problemSlug] = {
          ...newState[action.problemSlug],
          uploadStatus: action.status,
        };
      } else {
        newState[action.problemSlug] = {
          uploadStatus: action.status,
        };
      }

      return newState;
    }
    case `${ActionTypes.VIDEO_UPLOAD}_PROGRESS`: {
      const newState = { ...state };

      newState[action.problemSlug] = {
        ...newState[action.problemSlug],
        progress: action.progress,
      };

      return newState;
    }
    case `${ActionTypes.VIDEO_UPLOAD}_INCREMENT_RETRIES`:
    case `${ActionTypes.VIDEO_UPLOAD}_RESET_RETRIES`: {
      const newState = { ...state };

      newState[action.problemSlug] = {
        ...newState[action.problemSlug],
        totalRetries: action.totalRetries,
      };

      return newState;
    }
    case `${ActionTypes.AUDIO_UPLOAD}_INCREMENT_RETRIES`:
    case `${ActionTypes.AUDIO_UPLOAD}_RESET_RETRIES`: {
      const newState = { ...state };

      newState[action.problemSlug] = {
        ...newState[action.problemSlug],
        totalRetries: action.totalRetries,
      };

      return newState;
    }
    default:
      return state;
  }
};
